import React, { useEffect, useRef } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import QuotationOrderEdit from './QuotationOrderEdit';
import { Button, Image } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import moment from 'moment';
import DownloadExcel from '../../report/DownloadExcel';

export default function AliVoice(props: any) {

    const ref = useRef<any>(undefined);

    /** api服务id */
    const apiId = 'quotationOrder';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据




    //表头
    const columnsHead = [
        {
            title: '报价状态',
            dataIndex: 'quotationStatusName',
            // render: (text: any, record: any) =>
            //     <div>{record.voiceId}</div>
        },
        {
            title: '有效期',
            dataIndex: 'voiceId',
            render: (text: any, record: any) => {
                
                return <>{record.isForEver?"永久":`${ moment(record.startTime).format("YYYY-MM-DD HH:mm:ss")}~${moment(record.endTime).format("YYYY-MM-DD HH:mm:ss")}`}</>
            }
        },
        {
            title: '提交时间',
            dataIndex: 'submissionTime',
            render: (text: any, record: any) => {
                
                return <>{text?`${ moment(text).format("YYYY-MM-DD HH:mm:ss")}`:""}</>
            }
        },
         {
            title: '报价名称',
            dataIndex: 'quotationOrderName',

        },
        {
            title: '采购商',
            dataIndex: 'buyerName',

        },
        {
            title: '采购商电话',
            dataIndex: 'buyerPhone',

        },
        // buyerPhone
        {
            title: '报价人',
            dataIndex: 'contact',

        },
        {
            title: '报价人电话',
            dataIndex: 'contactPhone',
        },
        {
            title: '审核',
            dataIndex: 'contactPhone',
            render: (text: any, record: any) => {
                switch (record.quotationStatus) {
                    case 2:
                        return <div><Button onClick={() => reviewQuotationOrder(record.id, 99)} size='small'>通过</Button> 或<Button onClick={() => reviewQuotationOrder(record.id, 1)} size='small'>回退</Button></div>
                    default:

                        return <></>
                }
            }

        },
        {
            title: '下载',
            dataIndex: 'contactPhone',
            render: (text: any, record: any) => {
                
              return  <Button disabled={record.quotationStatus===99?false:true} onClick={() => DownloadExcel(record, "quotationOrder", )}>下载EXCEL文件</Button>
            }


        },

    ];
    const reviewQuotationOrder = (id: string, quotationStatus: number) => {
        fetchApi.POST(wmService, {
            apiId: "quotationOrder",
            apiExtend: "reviewQuotationOrder",
            apiData: {
                quotationOrderId: id,
                quotationStatus
            }
        }).then((res) => {
            if (res.success) {
                const currentData: initDataType = {
                    apiId,
                }
                ref.current.initData(currentData);
            }
        }).catch((err) => {
            console.log(err);

        })
    }
    const columns = columnsheadId
        .concat(columnsHead as []);

    // 子表格列配置函数
    const getExpandableColumns = (mainRecord: any) => {
        return [
            {
                title: "产品",
                dataIndex: "productName",
            },
            {
                title: "单位",
                dataIndex: "productUnitName"
            },
            {
                title: "规格",
                dataIndex: "productSpecifications",
            },
            {
                title: "单价",
                dataIndex: "univalence"
            },
            {
                title: "备注",
                dataIndex: "memo"
            },
            {
                title: "产品合格证",
                dataIndex: 'productCertificateUrl',
                render: (text: any, subRecord: any) => {
                    return text ? (
                        <Image src={mainRecord.filesServerUrl + "/" + text} width={80} height={80} alt="产品图片" />
                    ) : '无证书';
                }
            }
        ];
    }
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '报价订单',
        apiId,
        columns,
        expandableColumns: getExpandableColumns,
        // showImage: true,
        // showUploadFile: true,
        expandableDataName: "quotationOrderProducts",
        showStates: true,
        pagination: true,
        bulkInsert: true,
        isExpandable: true,
        InsertComponent: QuotationOrderEdit,
        EditComponent: QuotationOrderEdit,
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
        </>
    )
}